import React, { Component } from 'react';
import './Or.css';

class Or extends Component {
  render() {
    return (
      <div className = "Or">
        <hr className = "OrClearer" />
        <span className = "OrText"><span className = "Inner">{this.props.text ? this.props.text : 'OR'}</span></span>
      </div>
    );
  }
}

export default Or;



// WEBPACK FOOTER //
// ./src/ui/Or.js